import { createAction, props } from '@ngrx/store';
import { ScoreboardTypeFilter } from './models';

export const filterTable = createAction('[Targeting] Set Table Filter', props<{ filter: ScoreboardTypeFilter }>());
